import { OverflownButtonsToolbar } from '../data-hooks';

export const getMoreToolbarElement = (dataHook: string) =>
  document.querySelector(
    `[data-hook~=${OverflownButtonsToolbar}] [data-hook~=${dataHook}]`
  ) as HTMLElement | null;
